<script setup lang="ts">
  import IconLabel from '@leaflink/stash/IconLabel.vue';
  import { I18nT } from 'vue-i18n';

  import { useUserStore } from '@/piniaStores/user/user.store';
  import i18n from '@/plugins/i18n';

  const userStore = useUserStore();
</script>

<template>
  <div class="tw-flex lg:tw-block tw-flex-col tw-h-full lg:tw-h-auto">
    <div>
      <div
        v-if="userStore.getIsSplitEnabled('fire_pod__direct_pay_seller_fee')"
        class="tw-bg-green-100 tw-p-3 tw-text-center"
      >
        <div class="tw-text-2xl tw-font-medium tw-text-green-700">
          {{ i18n.t('termsAndConditions.directPayTermsConfirmation.seller.processingRate') }}
        </div>
        <div class="tw-text-ice-900 tw-text-xs">
          {{ i18n.t('termsAndConditions.directPayTermsConfirmation.seller.processingRateDescription') }}
        </div>
      </div>
      <ul class="tw-space-y-3" :class="{ 'tw-mt-6': userStore.getIsSplitEnabled('fire_pod__direct_pay_seller_fee') }">
        <li>
          <IconLabel icon="circle-check" color="green-500" class="text-ice-900 tw-text-sm">
            {{ i18n.t('termsAndConditions.directPayTermsConfirmation.seller.bullet1') }}
          </IconLabel>
        </li>
        <li>
          <IconLabel icon="circle-check" color="green-500" class="text-ice-900 tw-text-sm">
            <template v-if="userStore.getIsSplitEnabled('fire_pod__direct_pay_seller_fee')">
              {{ i18n.t('termsAndConditions.directPayTermsConfirmation.seller.bullet2WithFees') }}
            </template>
            <template v-else>
              {{ i18n.t('termsAndConditions.directPayTermsConfirmation.seller.bullet2') }}
            </template>
          </IconLabel>
        </li>
        <li>
          <IconLabel icon="circle-check" color="green-500" class="text-ice-900 tw-text-sm">
            {{ i18n.t('termsAndConditions.directPayTermsConfirmation.seller.bullet3') }}
          </IconLabel>
        </li>
        <li>
          <IconLabel icon="circle-check" color="green-500" class="text-ice-900 tw-text-sm">
            {{ i18n.t('termsAndConditions.directPayTermsConfirmation.seller.bullet4') }}
          </IconLabel>
        </li>
      </ul>

      <h3 class="tw-mt-6 tw-mb-3">
        {{ i18n.t('termsAndConditions.self') }}
      </h3>
      <I18nT keypath="termsAndConditions.directPayTermsConfirmation.termsDescription" scope="global" tag="p">
        <template #payments>
          <strong>{{ i18n.t('common.payments') }}</strong>
        </template>
        <template #logistics>
          <strong>{{ i18n.t('common.logistics') }}</strong>
        </template>
      </I18nT>
    </div>
    <div class="tw-overflow-auto tw-flex-1 lg:tw-h-[180px] tw-bg-ice-100 tw-p-3">
      <div
        v-html="i18n.t('termsAndConditions.directPayTermsConfirmation.termsBody')"
        class="tw-text-ice-900 tw-text-xs"
      ></div>
    </div>
    <p class="tw-text-ice-900 tw-text-sm tw-mt-6 tw-mb-0">
      {{ i18n.t('termsAndConditions.directPayTermsConfirmation.legalNotice') }}
    </p>
  </div>
</template>
